/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useEffect } from 'react';

interface Props {
  path: string;
  sizes: [number, number][] | [number, number];
  id: string;
  target: string;
  chainId: string;
}
export const useAdSlot = ({ 
  path,
  sizes,
  id,
  target,
  chainId
}: Props) => {

  useEffect(() => {

    let slot: googletag.Slot | null = null;
    
    if (window !== undefined) {
      window.googletag = window.googletag || { cmd: [] };

      setTimeout(() => {
        const { googletag } = window;

        googletag.cmd.push(() => {
          googletag.pubads().setTargeting(target, chainId);
          const existingSlot = googletag.pubads().getSlots().find(s => s.getSlotElementId() === id);
          if (existingSlot) {
            googletag.destroySlots([existingSlot]);
          }
          slot = (googletag.defineSlot(path, sizes, id) as googletag.Slot).addService(googletag.pubads())
          googletag.pubads().enableSingleRequest();
          googletag.enableServices();
          googletag.display(id);
        });
      }, 500);
    }
    return () => {
      const { googletag } = window;
      if (googletag?.destroySlots && slot) {
        googletag.destroySlots([slot]);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chainId]);
};